import { api } from "./api";

export const addStockApi = (params) => {
    return api.post(`/inventory/add-stock`, JSON.stringify(params));
};

export const removeStockApi = (params) => {
    return api.post(`/inventory/remove-stock`, JSON.stringify(params));
};

export const newStockListApi = (params) => {
    return api.get(`/inventory/new-stock-list`, { params });
};

export const inventoryListApi = (params) => {
    return api.get(`/inventory/list`, { params });
};

export const productDropdownApi = (params) => {
    return api.get(`/inventory/product-list`, { params });
};

export const updateInventoryApi = (params) => {
    return api.post(`/inventory/update`, JSON.stringify(params));
};

export const editInventoryApi = (params) => {
    return api.post(`/inventory/edit`, JSON.stringify(params));
};

export const deleteInventoryApi = (params) => {
    return api.post(`/inventory/delete`, JSON.stringify(params));
};

export const stockReportApi = (params) => {
    return api.get(`/inventory/stock-report`, { params });
};

export const addStockReturnApi = (params) => {
    return api.post(`/inventory/add-stock-return`, JSON.stringify(params));
};

export const removeStockReturnApi = (params) => {
    return api.post(`/inventory/remove-stock-return`, JSON.stringify(params));
};

export const newStockReturnListApi = (params) => {
    return api.get(`/inventory/new-stock-return-list`, { params });
};

export const updateInventoryStockReturnApi = (params) => {
    return api.post(`/inventory/update-return`, JSON.stringify(params));
};

export const routesDropdownApi = (params) => {
    return api.get(`/inventory/routes-list`, { params });
};

export const customersDropdownApi = (params) => {
    return api.get(`/inventory/customers-list`, { params });
};

export const purchasedProductsDropdownApi = (params) => {
    return api.get(`/inventory/purchased-products-list`, { params });
};